<template>
  <base-layout pageTitle="TYPO3-API-Test">
    <div v-if="rssItems.length">
      <ul v-for="item in rssItems" :key="item.link">
        <li v-html="item.message"></li>
      </ul>
    </div>
    <div v-else>
      Loading...
    </div>
  </base-layout>
</template>






<script>
import axios from 'axios';
// import { IonHeader, IonMenu, IonTitle, IonToolbar, IonContent, IonPage, IonList, IonItem, IonLabel } from '@ionic/vue';
// import AppHeader from "@/components/page/Header.vue";
// import AppFooter from "@/components/page/Footer.vue";


export default {
  name: 'Typo3ApiPage',
  components: {
    // IonLabel, IonList, IonItem,
    // IonButton, IonButtons,
    // AppHeader,
    // AppFooter,
    // IonHeader,
    // IonMenu,
    // IonTitle,
    // IonToolbar,
    // IonContent,
    // IonPage
  },
  data() {
    return {
      rssItems: [],
    };
  },
  created() {
    this.fetchRssFeed();
  },
  methods: {
    async fetchRssFeed() {
      try {
        const response = await axios.get('https://www.gmm-konferenz.de/api/chat/messagesByEvent/4');
        // https://www.gmm-konferenz.de/index.php?id=21&tx_streamingchat_eventshowaction%5D=show&tx_streamingchat_eventshow%5Bcontroller%5D=Event&tx_streamingchat_eventshow%5Bevent%5D=4&tx_streamingchat_eventshow%5BregistrationId%5D=55&token=5e15wvao40owsgwg
        const items = response.data; // Assuming the JSON response is an array of items
        this.rssItems = items.map(item => ({
          message: item.message,
          description: item.description,
          link: item.link,
        }));
      } catch (error) {
        console.error('Error fetching RSS feed:', error);
      }
    },
    navigateTo(page) {
      this.$router.push({ name: page });
    },
  },
};
</script>

<style scoped>
ion-page {
  height: 100%;
}

ion-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.slider-image {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.slider-container {
  max-width: 1140px;
  width: 100%;
  margin: 0 auto;
}
</style>
<script setup lang="ts">
</script>